angular.module('leanlaw').controller('MatterTagBillablesCtrl', ['$scope', '$rootScope', '$q', '$filter', '$timeout', '$stateParams', '$state', "alerts", 'userService', 'reportsService', 'commonFilterService', "exportJson", "singleRequest", "messageBus", function ($scope, $rootScope, $q, $filter, $timeout, $stateParams, $state, alerts, userService, reportsService, commonFilterService, exportJson, singleRequest, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'mattertag.label';
  $scope.reverse = false;
  $scope.print = function () {
    window.print();
  };
  $scope.export = function () {
    const matter = $scope.me.terms.Matter;
    const exp = $scope.data.filteredMatterTags.reduce((accum, c) => {
      let exportObj = {
        "Practice Area": c.mattertag.label,
        "Non-Billable Hours": $filter("hoursDecimal")(c.data.hours.nonBillable),
        "Billable Hours": $filter("hoursDecimal")(c.data.hours.billable),
        "Hours Amount": $filter("amount")(c.data.amounts.hours)
      };
      exportObj["Fixed Fee Hours"] = $filter("hoursDecimal")(c.data.hours.charges);
      exportObj = {
        ...exportObj,
        "Fixed Fees": $filter("amount")(c.data.amounts.charges),
        "Expenses": $filter("amount")(c.data.amounts.expenses),
        "Total Amount": $filter("amount")(c.data.amounts.total)
      };
      accum.push(exportObj);
      return accum;
    }, []);
    exportJson.downloadCsv(exp);
  };
  $scope.loading = true;
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    if (!payload) return;
    $scope.filter = Object.assign($scope.filter, payload);
    $scope.filter.status = $scope.filter.archived.status;
    $scope.filter.scope = $scope.filter.filter.scope;
    $scope.filter.billedState = $scope.filter.billedFilter && $scope.filter.billedFilter.id;
    filterClientEntries();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    $scope.filter = Object.assign($scope.filter, payload);
  });

  // MessageBus is used here so that the commonFilter module can pick it up once it loads
  messageBus.addMessage("filterDependency-ready", true);
  function filterClientEntries() {
    console.log($scope.filter);
    $scope.loading = true;
    var query = reportsService.queryFromFilter($scope.filter);
    query.data = "services,expenses,charges,hours";
    query.primary = 'mattertag';
    query.reportType = 'billable';
    singleRequest.serviceCall("report", reportsService.getReport)(query).then(data => {
      if (!data) return;
      $scope.data = data;
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("report");
    deactivate();
  });
  $scope.goToSummary = function (tag) {
    console.log(tag);
    $state.go("reports.practice-area-billables-detail", {
      matterTag: tag.id,
      return: "reports.practice-area-billables",
      report: `Practice Area Billables`
    });
  };

  // The rows the table shows. Precomputed here rather than assigned from the
  // ng-repeat expression, which re-ran the filter and sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredMatterTags = $filter('orderBy')($filter('filter')($scope.data.matterTags, $scope.search), $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.matterTags', updateFiltered);
  $scope.$watch('search', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);